// extracted by mini-css-extract-plugin
export default {"trigger":"Tooltip_trigger__6QbAe","content":"Tooltip_content__dCZWG"};